// @file Alert dialog helpers
// Keep payloads here to avoid variations of the same alert.
import { __ } from '@@/bits/intl'
import type { AlertDialogPayload } from '@@/pinia/global_alert_dialog'

export const INVALID_FILE_TYPE_ALERT: AlertDialogPayload = {
  title: __('Invalid file type'),
  body: __('Sorry, the file you selected is not supported.'),
}

export const ATTACHMENT_UPLOAD_ERROR_ALERT: AlertDialogPayload = {
  title: __('There was an error loading the attachment'),
  body: __('Sorry, there was an error uploading your file.'),
}

export default {
  INVALID_FILE_TYPE_ALERT,
  ATTACHMENT_UPLOAD_ERROR_ALERT,
}
